<script>
  import Bio from "./Bio.svelte";
</script>

<div id="short-intro" class="section">
  <div class="container">
    <div class="row center">
      <p class="flow-text intro-text">
        Welcome to my online portfolio and a curated selection of my artwork!
      </p>

      <Bio />
    </div>
  </div>
</div>

<style>
  #short-intro {
    background-color: #efebe97e;
  }

  @media screen and (min-width: 800px) {
    .intro-text {
      font-size: 1.35em;
    }
  }
</style>
